import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  title: {
    flex: 1,
    cursor: 'pointer'
  },
  appBar: {
    marginBottom: '10px'
  }
})